import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";

export const WhatYouGet = () => {
    const prefix = "//";

    const items = [
        "More customer inquiries and leads",
        "Professional online presence that builds trust",
        "Fast-loading website (no customer drop-offs)",
        "Mobile-first design for all devices",
        "Easy contact via WhatsApp, Email and calls",
        "SEO-ready structure to get found on Google"
    ];

    return (
        <section
            id="what-you-get"
            data-testid="what-you-get-section"
            className="relative py-24 md:py-40 overflow-hidden"
        >
            {/* Background */}
            <div className="absolute inset-0 bg-grid opacity-30" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-cyan-500/10 blur-[140px]" />

            <div className="relative max-w-5xl mx-auto px-6 md:px-10 text-center">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    {/* Section label */}
                    <div className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-400 mb-6">
                        {prefix} What you get
                    </div>

                    {/* Heading */}
                    <h2 className="text-5xl sm:text-6xl lg:text-6xl font-bold tracking-tighter leading-[0.9]">
                        Built for{" "}
                        <span className="text-gradient-cyan">
                            real business results
                        </span>
                    </h2>

                    {/* Subtext */}
                    <p className="mt-8 text-lg md:text-xl text-slate-400 max-w-2xl mx-auto leading-relaxed">
                        Every website is designed not just to look good, but to help your business attract customers, build trust, and grow consistently online.
                    </p>

                    {/* Items */}
                    <div className="mt-16 grid sm:grid-cols-2 gap-6 text-left max-w-3xl mx-auto">
                        {items.map((item, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 10 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                className="flex items-start gap-3 p-4 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm hover:border-cyan-400/40 transition-all"
                            >
                                <CheckCircle
                                    size={20}
                                    className="text-cyan-400 mt-1 shrink-0"
                                />
                                <span className="text-slate-300 text-base leading-relaxed">
                                    {item}
                                </span>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>
            </div>
        </section>
    );
};